<template>
    <div class="chat__room-item-main" v-if="infoDirectRooms !== null && infoDirectRooms.usernames[0] !== infoDirectRooms.usernames[1]">
        <div class = "chat__room-item-data-wrap-main">
            <div class="chat__room-item-data" @click="enterRoom(infoDirectUser.username,infoDirectRooms._id)">
                <div class="chat__room-item-data-img">
                    <userAvatar v-if="infoDirectUser !== null" :userLogin="infoDirectUser !== null ? infoDirectUser.username : ''"/>
                </div>
                <div class="chat__room-item-data-name" >
                    <a href="#" >
                        {{infoDirectUser !== null ? infoDirectUser.name : ''}}
                    </a>
                    <div class="chat__room-item-data-users">
                        {{infoDirectUser !== null ? infoDirectUser.status : ''}}
                    </div>
                </div>
            </div>
            <div class="chat__room-item-data-status" v-if="getInfoForRoom.newMessages">
                <div class="chat__room-item-data-alert"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { setTimeout } from 'timers';
import userAvatar from '../ui-components/chat-avatar'
export default {
    components: {
        userAvatar
    },
    props: ['roomInfo','count'],
    data() {
        return {
            infoDirectRooms:null,
            infoDirectUser:null
        }
    },
    computed: {
        ...mapGetters({
            getToken:'chat/restAuthToken',
            getUserLogin:'chat/restUserId',
            userLogin:'chat/userInfo',
            getApiChatUri:'api/getChatRestUri',
            infoRoom:'chat/getUsersInRoom'
        }),
        getInfoForRoom() {
            let info = {
                cnt:0,
                lastMessage:new Date(),
                readStatus:true
            };
            if (this.infoRoom.length !== 0)
                for(let i = 0; i < this.infoRoom.length; i++) {
                    if(this.roomInfo._id === this.infoRoom[i].idRoom) {
                        info.cnt = this.infoRoom[i].cnt;
                        info.lastMessage =  this.infoRoom[i].lastMessage;
                        info.newMessages = this.infoRoom[i].newMessages;
                    }
                }
            return info;
        }
    },
    methods: {
        async getNameDirectUser() {
           if(!this.roomInfo && !this.getToken && !this.getUserLogin)
            return
            let query = {
                method: 'GET',
                url: this.getApiChatUri + 'rooms.info?roomId=' + this.roomInfo._id,
                headers: {
                    'X-Auth-Token': this.getToken,
                    'X-User-Id': this.getUserLogin,
                }
            }
            await axios(query).then(response => {
                this.infoDirectRooms =  response.data.room;},
            );
        },
        async getInfoUser() {
            await this.getNameDirectUser();
            let login = '';
            this.infoDirectRooms.usernames[1] === this.userLogin.username ? login = this.infoDirectRooms.usernames[0] : login = this.infoDirectRooms.usernames[1]
            let query = {
                method: 'GET',
                url: this.getApiChatUri + 'users.info?username=' + login,
                headers: {
                    'X-Auth-Token': this.getToken,
                    'X-User-Id': this.getUserLogin,
                }
            }
            await axios(query).then(response => {
                this.infoDirectUser = response.data.user;},
            );
        },
        enterRoom(userId,roomId) {
            this.$store.dispatch('chat/enterDirectRoom',userId);
            this.$store.commit('chat/setReadStatus', roomId);
            this.$emit('setRoom', roomId);
            //this.currentRoom = roomId;
        }
    },
    watch: {
        getInfoForRoom: function (value) {
            if(value.newMessages) {
                const myAudio = new Audio;
                myAudio.src = (require("../../assets/sound/chat-alert.mp3"));
                let promise = myAudio.play();
                if (promise !== undefined) {
                    promise.then(_ => {
                    //Auto
                    myAudio.play();
                    }).catch(error => {
                    });
                }
            }
        },
        getLogin: function() {
            this.currentRoom = '';
        }
    },
    mounted() {
        setTimeout(()=>{
           this.getInfoUser()
        },this.count * 100);
    }
}
</script>
<style lang="less" scoped>
 .chat__room {
    &-item {
        &-main {
            display: flex;
            cursor: pointer;
            background: #374b62;
            min-width: 360px;
        }
        &-data-wrap-main {
            display: flex;
            flex-grow: 1;
            border-bottom: 1px solid #324258;
            box-sizing: border-box;
        }
        &-data {
            flex-grow: 1;
            display: flex;
            padding: 12px;
            &-return {
                display:flex;
                align-items: center;
                padding-right: 12px;
                cursor: pointer;
                margin-left: auto;
                i {
                    font-size: 23px;
                    color: #a1b7cc;
                }
                &_text {
                    font-family: Arimo;
                    font-size: 13px;
                    font-weight: normal;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.54;
                    letter-spacing: 0.4px;
                    text-align: left;
                    color: #a1b7cc;
                    text-decoration: none;
                    text-transform: uppercase;
                }
            }
            &-img {
                margin-right: 16px;

            }
            &-users {
                font-family: Arimo;
                font-size: 13px;
                font-weight: 400;
                color:#a1b7cc;
                line-height: 1.54;
            }
            &-name a {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.54;
                letter-spacing: 0.4px;
                text-align: left;
                color: #ffffff;
                text-decoration: none;
                text-transform: uppercase;
            }
            &-status {
                display: flex;
                align-items: center;
                margin-left: auto;
                padding-right: 23px;
            }
            &-alert {
                background: #00ffd0;
                width:16px;
                height: 16px;
                border-radius: 16px;
            }
        }
    }
}
</style>
